import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resetUserSession } from './service/AuthService';
import './css/Daily.css';

const Settings = () => {
    const navigate = useNavigate();

    const handleDeleteAccount = () => {
        // TODO: call account deletion API when backend is ready
        resetUserSession();
        navigate('/login');
    };

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">Trampoline Health Settings</h2>
                    <p className="inDevelopmentCopy">
                        Notifications, your data, and information about Trampoline.
                    </p>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Application Settings</h5>
                    <div className="homeBttnContainer supportActions">
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/notifications')}
                        >
                            Notifications
                        </button>
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/in-development')}
                        >
                            Security & Data
                        </button>

                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/about')}
                        >
                            About Trampoline
                        </button>
                    </div>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Account Settings</h5>
                    {/* <p className="inDevelopmentCopy inDevelopmentCopy--card">
                        Permanently remove your account and associated data from Trampoline Health.
                    </p> */}
                    <div className="homeBttnContainer supportActions">
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => {window.open("https://billing.stripe.com/p/login/cNi00c3LV1E75cPgo42cg00", "_blank");}}
                        >
                            Manage Membership
                        </button>
                        <button
                            type="button"
                            className="homeBttn membershipBttnCancel"
                            onClick={handleDeleteAccount}
                        >
                            Delete My Account
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
